module.exports = __webpack_public_path__ + "img/wxgzh.f658f2fc.jpg";